const BASE64_IMAGE_SIGNATURES = [
	{ signature: "/9j/", mimeType: "image/jpeg" },
	{ signature: "iVBORw0KGgo", mimeType: "image/png" },
	{ signature: "UklGR", mimeType: "image/webp" },
	{ signature: "R0lGOD", mimeType: "image/gif" },
];

/** Turns a raw base64 image sent by the API into a data URI; any URL or data URI is kept as is. */
export const toThumbnailSrc = (thumbnail?: string | null): string | undefined => {
	if (!thumbnail) {
		return undefined;
	}

	const compactThumbnail = thumbnail.replace(/\s/g, "");
	const base64Image = BASE64_IMAGE_SIGNATURES.find(({ signature }) =>
		compactThumbnail.startsWith(signature)
	);

	if (!base64Image) {
		return thumbnail;
	}

	return `data:${base64Image.mimeType};base64,${compactThumbnail}`;
};
